// extracted by mini-css-extract-plugin
module.exports = {"main_container":"SendToDexBalControl_main_container__1MGKd"};